import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from '../components/HelloWorld.vue';
import English from '../components/EnglishLuage.vue';
import Netherland from '../components/NetherlandLuage.vue';
import FranceLuage from '../components/FranceLuage.vue';
import IosManual from '../components/IosManual.vue';
import IosEnglish from '../components/IosEnglish.vue';
import IosNetherland from '../components/IosNetherland.vue';
import IosFrance from '../components/IosFrance.vue';
import DeutschLuage from '../components/DeutschLuage.vue';
import IosDeutsch from '../components/IosDeutsch.vue';
import DualTag from '@/components/DualTag.vue';
import DualCard from '@/components/card/DualCard.vue';
import AndroidCard from '@/components/card/AndroidCard.vue';
import IosManualCard from '@/components/card/IosManualCard.vue';
import CardEnglishLuage from '@/components/card/IosCardEn.vue';
import CardDutchLanguage from '@/components/card/IosCardNl.vue';
import CardFrenchLanguage from '@/components/card/IosCardFr.vue';
import CardGermanLanguage from '@/components/card/IosCardDe.vue';
import AndroidEnglishGuide from '@/components/card/AndroidCardEn.vue';
import AndroidCardDutchGuide from '@/components/card/AndroidCardNl.vue';
import AndroidCardFrenchGuide from '@/components/card/AndroidCardFr.vue';
import AndroidCardGermanGuide from '@/components/card/AndroidCardDe.vue';
import IosSpanish from '../components/IosSpanish.vue';
import Spanish from '../components/SpanishLuage.vue';

const routes = [
  { path: '/', component: HelloWorld },
  { path: '/dual', component: DualTag },
  { path: '/android', component: HelloWorld },
  { path: '/dual/android', component: HelloWorld },
  { path: '/ios', component: IosManual },
  { path: '/dual/ios', component: IosManual },

  { path: '/android/english', component: English },
  { path: '/android/nl', component: Netherland },
  { path: '/android/fr', component: FranceLuage },
  { path: '/android/de', component: DeutschLuage },
  { path: '/android/es', component: Spanish },
  

  { path: '/ios/english', component: IosEnglish },
  { path: '/ios/nl', component: IosNetherland },
  { path: '/ios/fr', component: IosFrance },
  { path: '/ios/de', component: IosDeutsch },
  { path: '/ios/es', component: IosSpanish },

  { path: '/card/dual', component: DualCard },
  { path: '/card/dual/android', component: AndroidCard },
  { path: '/card/dual/ios', component: IosManualCard },
  { path: '/card/dual/ios/en', component: CardEnglishLuage },
  { path: '/card/dual/ios/nl', component: CardDutchLanguage },
  { path: '/card/dual/ios/fr', component: CardFrenchLanguage },
  { path: '/card/dual/ios/de', component: CardGermanLanguage },
  { path: '/card/dual/android/en', component: AndroidEnglishGuide },
  { path: '/card/dual/android/nl', component: AndroidCardDutchGuide },
  { path: '/card/dual/android/fr', component: AndroidCardFrenchGuide },
  { path: '/card/dual/android/de', component: AndroidCardGermanGuide },

  
  
  
  

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;